import { Component, OnInit } from '@angular/core';

import { AppData } from '../services/appdata.service';
import { Global } from '../services/global.service';

@Component({
  selector: 'app-middleware',
  templateUrl: './middleware.component.html',
  styleUrls: ['./middleware.component.css']
})
export class MiddlewareComponent implements OnInit
{

	constructor(
		private appData: AppData,
		private global: Global
	)
	{
		this.appData.set('current_app', 'login_middleware');
		this.appData.set('app_name', 'login_middleware');
	}

	ngOnInit(): void
	{
		this.global.initLoginMiddleware(
			{	
				"url": window.location.href
			}
		);
	}

}
